import React, { useEffect, useState, useRef } from "react";
import { KeyboardDatePicker } from "@material-ui/pickers";
import { OverlayPanel } from "primereact/overlaypanel";
import { Card } from "react-bootstrap";
import Illustration from "../../../../partials/content/Illustration";
import NumberFormat from "react-number-format";
import CustomDataTable from "../../../../partials/content/CustomDataTable";
import { getDirectSalesReport } from "../../../../services/crm/crmReportService";
import { formatDate } from "../../../../utils/utils";
import { useGlobalData } from "../../../../../provider/GlobalDataProvider";
import ResponsiveEllipsis from "../../../../partials/content/ResponsiveEllipsis";
import { DateTime } from "luxon";
import BootstrapTooltip from "../../../../partials/content/BootstrapTooltip";

function DirectSalesReport(props) {
  const { reload } = useGlobalData();
  const selectParamOp = useRef(null);
  const [selectParam, setSelectParam] = useState({
    dateFrom: DateTime.now().startOf("month"),
    dateTo: DateTime.now().endOf("month"),
  });
  const [directSales, setDirectSales] = useState([]);

  useEffect(() => {
    getDirectSalesData();
  }, [reload]);

  return (
    <React.Fragment>
      <OverlayPanel
        ref={selectParamOp}
        showCloseIcon
        dismissable={false}
        id="overlay_panel"
        style={{ width: "450px" }}
        className="overlaypanel-demo"
      >
        <div className="row mb-3">
          <div className="col-sm-12 col-md-12 col-lg-12">
            <Card>
              <Card.Header>
                <i className="fas fa-filter"></i>
                <span>
                  <strong>Filter Selection</strong>
                </span>
              </Card.Header>
              <Card.Body>
                <div className="row">
                  <div className="col-6">
                    <KeyboardDatePicker
                      label="Date From"
                      autoOk
                      size="small"
                      inputVariant="outlined"
                      variant="inline"
                      margin="normal"
                      value={selectParam.dateFrom}
                      onChange={(date) => {
                        const selectParamTmp = { ...selectParam };
                        selectParamTmp.dateFrom = date;
                        setSelectParam(selectParamTmp);
                      }}
                      format="yyyy-MM-dd"
                      InputProps={{ readOnly: true }}
                    />
                  </div>
                  <div className="col-6">
                    <KeyboardDatePicker
                      label="Date To"
                      autoOk
                      size="small"
                      inputVariant="outlined"
                      variant="inline"
                      margin="normal"
                      value={selectParam.dateTo}
                      onChange={(date) => {
                        const selectParamTmp = { ...selectParam };
                        selectParamTmp.dateTo = date;
                        setSelectParam(selectParamTmp);
                      }}
                      minDate={selectParam.dateFrom}
                      format="yyyy-MM-dd"
                      InputProps={{ readOnly: true }}
                    />
                  </div>
                </div>
              </Card.Body>
            </Card>
          </div>
        </div>
        <div className="row">
          <div className="col-sm-12 col-md-12 col-lg-12">
            <button
              type="button"
              className="btn btn-success btn-md btn-pill btn-bold float-right"
              onClick={() => {
                getDirectSalesData();
              }}
            >
              <i className="fas fa-search"></i>
              Get Direct Sales
            </button>
          </div>
        </div>
      </OverlayPanel>
      {directSales.length ? (
        <React.Fragment>
          <CustomDataTable
            data={directSales}
            onRefreshData={() => {
              getDirectSalesData();
            }}
            buttons={[
              {
                name: "Filter",
                onClick: (e) => {
                  selectParamOp.current.toggle(e);
                },
                icon: "fas fa-search",
                color: "info",
              },
            ]}
            columns={[
              {
                header: "Sales Journey Name",
                field: "journeyTitle",
                body: (rowData) => (
                  <React.Fragment>
                    <ResponsiveEllipsis
                      text={rowData.journeyTitle}
                      maxLine="1"
                    />
                  </React.Fragment>
                ),
                sortable: true,
                filter: true,
              },
              {
                header: "CustomerName",
                field: "customerName",
                body: (rowData) => (
                  <React.Fragment>
                    <ResponsiveEllipsis
                      text={rowData.customerName}
                      maxLine="1"
                    />
                  </React.Fragment>
                ),
                sortable: true,
                filter: true,
              },
              {
                header: "Sales Name",
                field: "salesName",
                body: (rowData) => (
                  <React.Fragment>
                    <ResponsiveEllipsis text={rowData.salesName} maxLine="1" />
                  </React.Fragment>
                ),
                sortable: true,
                filter: true,
              },
              {
                header: "Sales Date",
                field: "salesDate",
                body: (rowData) => formatDate(rowData.salesDate),
                sortable: true,
                filter: true,
              },
              {
                header: "Item Type",
                field: "itemTypeName",
                body: (rowData) => (
                  <React.Fragment>
                    <ResponsiveEllipsis
                      text={rowData.itemTypeName}
                      maxLine="1"
                    />
                  </React.Fragment>
                ),
                sortable: true,
                filter: true,
                hidden: true,
              },
              {
                header: "Item Code",
                field: "itemCode",
                body: (rowData) => (
                  <React.Fragment>
                    {rowData.itemType > 0 ? (
                      <span>
                        <BootstrapTooltip title={rowData.itemTypeName}>
                          <span className="mr-2">
                            <i
                              className={
                                rowData.itemType === 1
                                  ? "fas fa-boxes text-success"
                                  : rowData.itemType === 2
                                  ? "fas fa-tools text-primary"
                                  : rowData.itemType === 3
                                  ? "fas fa-building text-info"
                                  : rowData.itemType === 4
                                  ? "fas fa-boxes text-warning"
                                  : rowData.itemType === 5
                                  ? "fas fa-boxes text-danger"
                                  : null
                              }
                            ></i>
                          </span>
                        </BootstrapTooltip>
                        <span>
                          <ResponsiveEllipsis
                            text={rowData.itemCode}
                            maxLine="1"
                            displayInline
                          />
                        </span>
                      </span>
                    ) : (
                      <React.Fragment>
                        <ResponsiveEllipsis
                          text={rowData.itemCode}
                          maxLine="1"
                        />
                      </React.Fragment>
                    )}
                  </React.Fragment>
                ),
                sortable: true,
                filter: true,
              },
              {
                header: "Item Name",
                field: "itemName",
                body: (rowData) => (
                  <React.Fragment>
                    <ResponsiveEllipsis text={rowData.itemName} maxLine="1" />
                  </React.Fragment>
                ),
                sortable: true,
                filter: true,
              },
              {
                header: "Quantity",
                field: "qty",
                body: (rowData) => (
                  <div>
                    {rowData.qty} {rowData.uomName}
                  </div>
                ),
                sortable: true,
                filter: true,
              },
              {
                header: "Unit",
                field: "uomName",
                body: null,
                sortable: true,
                filter: true,
                hidden: true,
              },
              {
                header: "Currency",
                field: "currencyCode",
                body: null,
                sortable: true,
                filter: true,
                hidden: true,
              },
              {
                header: "Unit Price",
                field: "unitPrice",
                body: (rowData) => (
                  <NumberFormat
                    value={rowData.unitPrice}
                    displayType={"text"}
                    thousandSeparator={true}
                    decimalScale={2}
                    renderText={(value) => (
                      <div className="float-right">
                        {rowData.currencyCode} {value}
                      </div>
                    )}
                  />
                ),
                sortable: true,
                filter: true,
              },
              {
                header: "Total Price",
                field: "totalPrice",
                body: (rowData) => (
                  <NumberFormat
                    value={rowData.totalPrice}
                    displayType={"text"}
                    thousandSeparator={true}
                    decimalScale={2}
                    renderText={(value) => (
                      <div className="float-right">
                        {rowData.currencyCode} {value}
                      </div>
                    )}
                  />
                ),
                sortable: true,
                filter: true,
              },
            ]}
          />
        </React.Fragment>
      ) : (
        <React.Fragment>
          <Illustration
            imageSource="INVIFO Sales.png"
            description={`You don't have any Direct Sales for current data selection!`}
            guidance={`Hint: Try to filter another data selection to get some results`}
            descriptionLeftIcon="fas fa-info-circle kt-font-info"
            size="md"
          ></Illustration>
          <div className="text-center py-3">
            <button
              type="button"
              className="btn btn-info btn-md btn-pill btn-bold mx-1"
              onClick={(e) => {
                selectParamOp.current.toggle(e);
              }}
            >
              <i className="fas fa-search"></i>
              Filter
            </button>
          </div>
        </React.Fragment>
      )}
    </React.Fragment>
  );

  async function getDirectSalesData() {
    const response = await getDirectSalesReport(
      selectParam.dateFrom,
      selectParam.dateTo
    );
    const { data } = response.data;
    setDirectSales(data.directSalesReport);
  }
}

export default DirectSalesReport;
